import Modal from './Modal';
import cookieInstance from './Cookie';
import { addMedthodsClassesFromList, filterItemsByDataValue } from './shared';
function anchorScroll() {
  $('a.js-anchor-list-link').click(function () {
    var offset = 0; // <-- change the value here
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top + offset
        }, 1000);
        return false;
      }
    }
  });
}
var navOpen = false;
function headerToggler() {
  const body = document.querySelector('body');
  const toggler = document.querySelector('.header .navbar-toggler');
  if (!toggler) return;
  toggler.addEventListener('click', function (e) {
    e.preventDefault();
    if (navOpen == true) {
      navOpen = false;
    } else {
      setTimeout(function () {
        navOpen = true;
      }, 250);
    }
    body.classList.toggle('nav-active');
    this.classList.toggle('active');
  });
}
function navCloser() {
  const body = document.querySelector('body');
  const toggler = document;
  if (!toggler) return;
  toggler.addEventListener('click', function (e) {
    //e.preventDefault();
    if (navOpen == true) {
      body.classList.remove('nav-active');
      document.querySelector('.header .navbar-toggler').classList.remove('active');
      navOpen = false;
    }
  });
}
function simpleTab() {
  const container = document.querySelectorAll('.js-tab-container');
  if (!container) return;
  const selectors = {
    links: '.js-tab-item-link',
    items: '.js-tab-item',
    hiddenElCls: 'el-none',
    activeLink: 'active',
    dataItemCategory: 'id'
  };
  container.forEach(containerItem => {
    const $tabLinks = containerItem.querySelectorAll(selectors.links);
    const $itemsEl = containerItem.querySelectorAll(selectors.items);
    if (!$tabLinks) return;
    $tabLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetCategory = this.getAttribute('href').slice(1);
        addMedthodsClassesFromList($tabLinks, 'remove', selectors.activeLink);
        addMedthodsClassesFromList($itemsEl, 'add', selectors.hiddenElCls);
        this.classList.add(selectors.activeLink);
        filterItemsByDataValue($itemsEl, selectors.dataItemCategory, targetCategory, selectors.hiddenElCls);
      });
    });
  });
}
function notificationModal() {
  const modalObj = new Modal({
    container: '.js-modal-notification',
    modalOverlayCls: 'js-modal-notification-overlay',
    btnCloseModal: '.js-modal-notification-close',
    closeCallback: () => {
      cookieInstance.setCookie(cookieData);
    }
  });
  const cookieData = {
    name: 'notification',
    value: true,
    days: 30
  };
  if (typeof cookieInstance.getCookie(cookieData.name) === 'undefined') {
    modalObj.openModal();
  }
}
function anchorDown() {
  const anchor = document.querySelector('.arrow-anchor-bottom');
  if (!anchor) return;
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const section = jQuery(e.target).closest('section')[0];
    $("html, body").animate({
      scrollTop: jQuery(section).height()
    }, 1000);
  });
}
function headerSubmenuMobile() {
  const breakpoint = 768;
  let counter = 0;
  function initialize() {
    if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
      if (counter === 1) {
        submenuInit();
      }
      counter++;
    } else {
      const submenus = jQuery('.js-header-nav-submenu');
      submenus.attr('style', '');
      counter = 0;
    }
  }
  if (window.innerWidth < breakpoint) {
    submenuInit();
    counter = 1;
  }
  function submenuInit() {
    const navigation = document.querySelector('.js-header-nav');
    if (!navigation) return;
    const navItems = navigation.querySelectorAll('.menu-wrapper > .menu-item');
    navItems.forEach(function (item, index) {
      const link = item.querySelector('.js-header-nav-link');
      const isHasSubmenu = item.querySelector('.sub-menu');
      if (!isHasSubmenu) return;
      let counterClick = 0;
      item.addEventListener('click', function (e) {
        if (counterClick === 0) {
          e.preventDefault();
          //jQuery(isHasSubmenu).slideToggle();
        }

        counterClick++;
      });
    });
  }
  initialize();
}
export default function common() {
  anchorScroll();
  navCloser();
  headerToggler();
  anchorDown();
  simpleTab();
  notificationModal();
  headerSubmenuMobile();
}